import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-quest-set-dialog',
  templateUrl: './manual-quest-set-dialog.component.html',
  styleUrls: ['./manual-quest-set-dialog.component.css'],
  standalone: false,
})
export class ManualQuestSetDialogComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly uploaderDLLink: string = AppConst.ROUTING_LINK_MANUAL_UPLOADER_DL;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
